export default {
    TOGGLE_LEFT_PANEL: 'TOGGLE_LEFT_PANEL',
};
